module.exports = __webpack_public_path__ + "img/sofia_schmid_2.77d5a6fe.jpg";